import { DiTokens } from "../../services/diTokens";
import { CatalogData } from "../../data/catalogData";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { StatementModel } from "../../models/statement/statementModel";
import { ChargeData } from "../../data/chargeData";
import ICatalogService from "../../services/catalog/ICatalogService";
import { container } from "@/inversify.config";
import { BankProductData } from "../../data/bankProductData";
import i18n from "@/i18n";

@Module({
  name: "catalog",
  namespaced: true
})
export class CatalogStore extends VuexModule {
  get catalogService(): ICatalogService {
    return container.get<ICatalogService>(DiTokens.CatalogService);
  }

  /** Список всех операций */
  public catalog: CatalogData = new CatalogData();

  /** Флаг зругзуки операций с сервера */
  public catalogLoading: boolean = true;

  public operationsHistory: StatementModel = new StatementModel({
    token: "OperationsHistoryService",
    title: i18n.t("main.operations.operationsHistory"),
    isChart: false,
    isSearch: true,
    isPeriod: true,
    statusBar: [1, 2, 3]
  });

  public static getDefaultState: Function = () => {
    return {
      catalog: new CatalogData(),
      catalogLoading: true,
      operationsHistory: new StatementModel({
        token: "OperationsHistoryService",
        title: i18n.t("main.operations.operationsHistory"),
        isChart: false,
        isSearch: true,
        isPeriod: true,
        statusBar: [1, 2, 3]
      }),
      bankProducts: new Array(),
      productsLoading: false,
      charges: new Array(),
      chargeDetailsProperties: new Array()
    }
  };

  public bankProducts: Array<BankProductData> = [];

  public productsLoading: boolean = true;

  public charges: Array<ChargeData> = [];

  public chargeDetailsProperties: Array<any> = [];

  public chargesLoading: boolean = false;

  /**Установка признака загрузки */
  @Mutation
  setLoading(loading: boolean) {
    this.catalogLoading = loading;
  }

  @Mutation
  resetStates() {
    Object.assign(this, CatalogStore.getDefaultState());
  }

  /**Установка признака загрузки */
  @Mutation
  setCatalog(catalog: CatalogData) {
    this.catalog = catalog;
  }

  @Mutation
  setBankProducts(products: Array<BankProductData>) {
    this.bankProducts = products;
  }

  @Mutation
  setCharges(charges: Array<ChargeData>): void {
    this.charges = charges;
  }

  @Mutation
  setChargesLoading(loading: boolean): void {
    this.chargesLoading = loading;
  }

  @Mutation
  setProductsLoading(loading: boolean): void {
    this.productsLoading = loading;
  }

  @Mutation
  setChargeDetailsProperties(props: any): void {
    this.chargeDetailsProperties = props;
  }

  @Action
  async fetchCatalog(id: number) {
    this.setLoading(true);
    const resCatalog = await this.catalogService.getCatalogAsync(id);
    this.setLoading(false);
    if (id !== 0) return resCatalog;
    else this.setCatalog(resCatalog);
  }

  @Action
  async searchCatalog({ query, city }) {
    this.setLoading(true);
    const resCatalog = await this.catalogService.searchCatalog(query, city);
    this.setCatalog(resCatalog);
    this.setLoading(false);
  }

  @Action
  async searchCatalogExt({ query, city }) {
    this.setLoading(true);
    const resCatalog = await this.catalogService.searchCatalogExt(query, city);
    this.setCatalog(resCatalog);
    this.setLoading(false);
  }

  @Action
  async fetchCharges(isAllChargesVisible: boolean = false): Promise<void> {
    this.setChargesLoading(true);
    const charges: Array<ChargeData> = await this.catalogService.fetchCharges(isAllChargesVisible);
    this.setCharges(charges);
    this.setChargesLoading(false);
  }

  @Action
  async getChargeProperties(path: string = ''): Promise<void> {
    this.setChargesLoading(true);
    if (path.length && !this.chargeDetailsProperties.length) {
      this.setChargeDetailsProperties(await this.catalogService.getChargeDetailsProperties(path));
    }
    this.setChargesLoading(false);
  }

  @Action
  public async fetchBankProducts() {
    this.setProductsLoading(true);
    const bankProducts: Array<BankProductData> = await this.catalogService.fetchBankProducts();
    this.setBankProducts(bankProducts);
    this.setProductsLoading(false);
  }
}
